import { LuminousGallery } from "../../../../node_modules/luminous-lightbox/es/lum.js";

const galleryOpts = {
  // Whether pressing the arrow keys should move to the next/previous slide.
  arrowNavigation: true,
  // A callback triggered when the image changes that is passed the image HTML element
  onChange: ({ imgEl }) => { },
};

const luminousOpts = {
  // These options have the same defaults and potential values as the Luminous class.
  sourceAttribute: "src",
  showCloseButton: true,
};

document.querySelectorAll(".gallery").forEach((gallery) => {
  const container = gallery.querySelector("ul");
  const slides = Array.from(container.querySelectorAll("li"));

  // Shuffles the slides first for randomness.
  slides.sort(() => Math.random() - 0.5);
  slides.forEach(slide => container.appendChild(slide));

  new LuminousGallery(
    gallery.querySelectorAll("img"),
    galleryOpts,
    luminousOpts
  );

});
